<template>
	<div class="wrap container">
		<router-view></router-view>
		<router-view name="foot"></router-view>
	</div>
</template>
<script>
	export default {
	  name: 'head',
	  data(){
	  	return{
	  		
	  	}
	  }
	}
</script>
<style>
  .container{
  	margin-bottom: 1.5rem;
  }
  .banner{
    width: 100%;
    display: block;
  }
  .public_head{
    position: relative;
  }
  .public_head_text{
    width: 3.21rem;
    height: 1.58rem;
    position: absolute;
    font-size: 0.336rem;
    color: #414042;
    background-image: url(/../../../static/images/yellow_bc2.png);
    background-size: cover;
    position: absolute;
    bottom: -0.3rem;
    right: 0.4rem
  }
  .public_head_text p{
    padding-top: 0.65rem;
    padding-left: 0.2rem;
    line-height: 0.4rem;
  }
  .common_title{
    padding:0.37rem 0 0.2rem 0.37rem;
    background-color: #fff;
    font-size: 0.2685rem;
    color: #6d6e71;
  }
  .common_title .icon{
    float: left;
    width: 0.5rem;
    height: 0.5rem;
    border-radius: 0.06rem 0 0.06rem 0;
    background-color: #fcd207;
    position: relative;
    margin-right: 0.1rem;
  }
  .common_title p{
    float: left;
    line-height: 0.6rem;
    font-weight: bold;
  }
  .common_title span{
    font-weight: normal;
  }
  .icon i.icons{
    display: inline-block;
    background-image: url(../../../static/images/icons.png);
    background-size: 3.24rem 2.51rem;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
  }
  img{
    max-width: 100%;
  }
</style>


// WEBPACK FOOTER //
// src/components/public/main.vue